import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { makeDefault } from './helpers/MakeDefault';
const BatModal = React.lazy(() => import('bat/BatModule').then(makeDefault('BatModal')));
export const LazyLoadBatModal = (importFunc, FallbackComponent) => React.lazy(() => import('bat/BatModule')
    .then(makeDefault('BatModal'))
    .then((module) => module)
    .catch((error) => {
    console.error('Bat Module failed to load...', error);
    return { default: FallbackComponent };
}));
const FallbackComponent = () => _jsx("div", { children: "Bat Module failed to load..." });
export const Bat = LazyLoadBatModal(BatModal, FallbackComponent);
